export default __webpack_public_path__ + "static/media/call us.972b7929.png";